import {
  PRODUCT_REVIEW_STATUS_I18N,
  resolveProductRowStatus,
} from '@/_services/product.service';

/** 审核状态码 → 与页头「审核状态」一致的 i18n key */
export function getApprovalReviewStatusI18nKey(statusCode) {
  const display = resolveProductRowStatus({ statusCode });
  return PRODUCT_REVIEW_STATUS_I18N[display] || PRODUCT_REVIEW_STATUS_I18N.toBeSubmitted;
}

/**
 * Finish 确认弹窗正文：from = 当前 approvalStatusCode，to = 驳回(R) / 通过(A)
 * @param {import('vue').default} vm
 * @param {{ isReject: boolean, currentStatusCode: * }} options
 */
export function buildApprovalConfirmDialogBody(vm, { isReject, currentStatusCode }) {
  const fromKey = getApprovalReviewStatusI18nKey(currentStatusCode);
  const toKey = isReject
    ? PRODUCT_REVIEW_STATUS_I18N.rejected
    : PRODUCT_REVIEW_STATUS_I18N.live;
  const bodyKey = isReject
    ? 'lbl_EMPBE_ProductInfo_ConfirmRejectBody'
    : 'lbl_EMPBE_ProductInfo_ConfirmApproveBody';
  return vm.$t(bodyKey, {
    fromStatus: vm.$t(fromKey),
    toStatus: vm.$t(toKey),
  });
}
